/**
 * Where Send Feedback was opened from, and where Back should return.
 * Screen ids only. No project, client, or record content.
 */
export function describeFeedbackOrigin({ currentScreen, moreOrigin = null }) {
  if (!currentScreen || currentScreen === "feedback") {
    return {
      returnScreen: "mode_select",
      sourceRoute: "mode_select → feedback",
      sourceScreen: "mode_select",
    };
  }

  if (currentScreen === "mode_select") {
    const prior = moreOrigin && moreOrigin !== "mode_select" && moreOrigin !== "feedback"
      ? moreOrigin
      : null;
    return {
      returnScreen: "mode_select",
      sourceRoute: prior ? `${prior} → mode_select → feedback` : "mode_select → feedback",
      sourceScreen: prior || "mode_select",
    };
  }

  return {
    returnScreen: currentScreen,
    sourceRoute: `${currentScreen} → feedback`,
    sourceScreen: currentScreen,
  };
}
